export function shuffle(arr: any[]) {
  for (var j, x, i = arr.length; i; j = Math.floor(Math.random() * i), x = arr[--i], arr[i] = arr[j], arr[j] = x);
  return arr;
}

export function capitalize (str: string | null) {
    return str && str.charAt(0).toUpperCase() + str.substr(1);
}



// WEBPACK FOOTER //
// ./src/engine/Utils.ts